export const iconFontAwesomeChartsDiagramsChartSimple = (
	<i className="fa-solid fa-chart-simple"></i>
);
